import { useState } from 'react';
import { downloadReportPDF } from '../../services/download.service';

export const useDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState('');

  const download = async (reportData) => {
    setIsDownloading(true);
    setError('');

    try {
      await downloadReportPDF(reportData);
    } catch (err) {
      setError('Failed to download PDF');
      console.error('Download error:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  const clearError = () => setError('');

  return { isDownloading, error, download, clearError };
};
